import { Tenant } from '../types/tenant';

export const GET_TENANT = 'GET_TENANT';

export type TenantAction = {
  type: 'GET_TENANT';
  data: Tenant;
};
